import React, { Component } from 'react'
import './../styles.css'

class Img extends Component {
  render () {
    const { src } = this.props
    return (
      <div className="img-event">
        {/* <div className="img_rgba" /> */}
        {/* <img src="/pic.jpg" /> */}
        <img src={src} alt="" />
        {/* <div className="textOnImg">
          {eventName.en}
        </div> */}
      </div>
    )
  }
}

export default Img



// WEBPACK FOOTER //
// ./src/App/EventPage/Components/Img.js